<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">

                        <el-form-item label="物料编码/型号" prop="matericalCode">
                            <el-input v-model="formInline.materialCode" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>

                        <el-form-item label="产地" prop="factory">
                            <brselect category="factory" :v="formInline.factory" :showcode="true"
                                      v-model="formInline.factory" clearable></brselect>
                        </el-form-item>

<!--                        <el-form-item class="right-btn">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
&lt;!&ndash;                            <el-button class="h-btn h-formBtn" @click="createAdvance">新增预借</el-button>&ndash;&gt;
                        </el-form-item>-->

                    </el-form>
                    <div class="l-screenBox">
<!--                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>-->
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" v-if="updateFlag" @click="addDeclaration" >新增报关主数据</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="型号"
                                :show-overflow-tooltip="true"
                                width="130">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="物料编码"
                                :show-overflow-tooltip="true"
                                min-width="90">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="oemDesc"
                                label="规格型号"
                                :show-overflow-tooltip="true"
                                min-width="130">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.oemDesc}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                label="产地"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="declarationName"
                                label="报关型号"
                                :show-overflow-tooltip="true"
                                width="130"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.declarationName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="hscode"
                                label="编码HSCODE"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.hscode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chineseName"
                                label="中文品名"
                                :show-overflow-tooltip="true"
                                width="180"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.chineseName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="englishName"
                                label="英文品名"
                                width="130"
                                :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.englishName}}
                                </div>
                            </template>
                        </el-table-column>

                      <el-table-column
                          prop="customsEnglishName"
                          label="清关英文名称"
                          width="130"
                          :show-overflow-tooltip="true"
                      >
                        <template slot-scope="scope">
                          <div style="text-align: left;">
                            {{scope.row.customsEnglishName}}
                          </div>
                        </template>
                      </el-table-column>

                        <el-table-column
                                prop="weight"
                                label="毛重"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="netWeight"
                                label="净重"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="measure"
                                label="尺"
                                width="110"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="volume"
                                width="80"
                                label="体积">
                        </el-table-column>
                        <el-table-column
                                prop="minTemperature"
                                width="110"
                                label="最低制冷温度">
                        </el-table-column>
                        <el-table-column
                                prop="contentProduct"
                                label="内容积"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="beizhu"
                                label="其他"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="brand"
                                label="品牌"
                                :show-overflow-tooltip="true"
                                width="130"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="primaryUom"
                                width="90"
                                label="基本单位">
                            <template slot-scope="scope">
                                <dictname category="YLUnit"  :v="scope.row.primaryUom"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                :formatter="formatDate"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                fixed="right"
                                width="180"
                        >
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            v-if="updateFlag"
                                            class="h-tableLink h-btn" @click="updateDeclaration(scope.row.id)">
                                        修改
                                    </el-button>
                                    <el-button
                                            type="text"
                                            size="small"
                                            v-if="updateFlag"
                                            class="h-tableLink h-btn" @click="deleteDeclaration(scope.row.id)">
                                        删除
                                    </el-button>
                                </div>


                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
                    <!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>-->
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="overseaExportDeclarationExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="updateVisDialogFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{uptitleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <el-form ref="form" :model="up" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">

                        <el-form-item label="物料编码" class="h-elformWrap-2" prop="materialCode" :rules="[{ required: true, message: '请输入物料编码', trigger: 'change'},]" >
                            <el-select v-model="up.materialCode"  remote filterable :filter-method="selectPro" clearable placeholder="请输入" allow-create filterable
                                       :remote-method="selectPro" @change="changePro" style="width: 90%">
                                <el-option v-for="(item) in materialList"
                                           :key="item.materialCode"
                                           :label="item.materialCode"
                                           :value="item.materialCode">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="型号" class="h-elformWrap-2" prop="materialName" :rules="[{ required: true, message: '请输入型号', trigger: 'change'},]" >
                            <el-input v-model="up.materialName" disabled style="width:90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="规格型号" class="h-elformWrap-2" prop="oemDesc">
                            <el-input v-model="up.oemDesc" disabled style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                            <el-input v-model="up.factory" disabled style="width: 90%;"></el-input>
                        </el-form-item>

<!--                        <el-form-item label="基本单位" class="h-elformWrap-2" prop="factory">
                            <el-input v-model="up.primaryUomName" disabled style="width: 90%;"></el-input>
                        </el-form-item>-->

                        <el-form-item label="报关型号" class="h-elformWrap-2" prop="declarationName">
                            <el-input v-model="up.declarationName" style="width: 90%"></el-input>
                        </el-form-item>

                        <el-form-item label="编码HSCODE" class="h-elformWrap-2" prop="hscode">
                            <el-input v-model="up.hscode" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="中文品名" class="h-elformWrap-2" prop="chineseName">
                            <el-input v-model="up.chineseName" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="英文品名" class="h-elformWrap-2" prop="englishName">
                            <el-input v-model="up.englishName" style="width: 90%;"></el-input>
                        </el-form-item>
                        <el-form-item label="清关英文名称" class="h-elformWrap-2" prop="customsEnglishName">
                          <el-input v-model="up.customsEnglishName" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="毛重" class="h-elformWrap-2" prop="weight">
                            <el-input v-model="up.weight" disabled style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="净重" class="h-elformWrap-2" prop="netWeight">
                            <el-input v-model="up.netWeight" disabled style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="尺(带底插)" class="h-elformWrap-2" prop="measure">
                            <el-input v-model="up.measure" disabled style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="体积" class="h-elformWrap-2" prop="volume">
                            <el-input v-model="up.volume" disabled style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="最低制冷温度" class="h-elformWrap-2" prop="minTemperature">
                            <el-input v-model="up.minTemperature" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="内容积" class="h-elformWrap-2" prop="contentProduct">
                            <el-input v-model="up.contentProduct" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="品牌" class="h-elformWrap-2" prop="brand">
                            <el-input v-model="up.brand" style="width: 90%;"></el-input>
                        </el-form-item>

                        <el-form-item label="其他" class="h-elformWrap-2" prop="beizhu">
                            <el-input v-model="up.beizhu" style="width: 90%;"></el-input>
                        </el-form-item>

                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">提交</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                tableData2:[],
                formInline: {
                    materialCode: null,
                    factory: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                up:{
                    materialCode:null,
                    materialName:null,
                    factory:null,
                    declarationName:null,
                    hscode:null,
                    chineseName:null,
                    englishName:null,
                    customsEnglishName:null,
                    weight:null,
                    netWeight:null,
                    volume:null,
                    measure:null,
                    minTemperature:null,
                    contentProduct:null,
                    beizhu:null,
                    brand:"海尔生物医疗牌/HAIER BIOMEDICAL",
                    id:null,
                    primaryUom:null,
                    // primaryUomName:null,
                    oemDesc:null,//oem产品描述
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                isScreen: false,
                materialList:[],
                updateFlag:false,
            }
        },
        //加载页面默认执行
        created() {
            this.formInline.searchDate = this.dateFormatter(new Date());
            if(this.$store.getters.hasRole('swyl_declaration_update') || this.$store.getters.hasRole('swyl_admin')){
                this.updateFlag = true;
            }
            this.query();
        },
        mounted() {

        },
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.factory = null;
                this.formInline.materialCode = null;
            },
            //检索
            query(){
                ss.declaration.selectPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //修改
            updateDeclaration(v){
                ss.declaration.selectById(v).then(rd => {
                    if(rd.f){
                        this.up = rd.msg;
                        this.uptitleDig = '修改报关主数据';
                        this.updateVisDialogFlag = true;
                    }
                })
            },
            deleteDeclaration(v){
                this.$msg.confirm("确认删除?", () => {
                    ss.declaration.deleteById(v).then(rd => {
                        if(rd.f){
                            this.query();
                        }
                    })
                })
            },
            //取消
            exit() {
                this.closeDialog()
            },
            //重置
            closeDialog(){
                this.updateVisDialogFlag = false;
                this.up.materialCode=null;
                this.up.materialName=null;
                this.up.factory=null;
                this.up.declarationName=null;
                this.up.hscode=null;
                this.up.chineseName=null;
                this.up.englishName=null;
                this.up.customsEnglishName=null;
                this.up.weight=null;
                this.up.netWeight=null;
                this.up.volume=null;
                this.up.measure=null;
                this.up.minTemperature=null;
                this.up.contentProduct=null;
                this.up.beizhu=null;
                this.up.brand="海尔生物医疗牌/HAIER BIOMEDICAL";
                this.up.id = null;
                this.up.oemDesc = null;
            },
            commitUpdate(){
                var data = {}
                data = this.up;
                ss.declaration.insertDeclaration(data).then(rd => {
                    if(rd.f){
                        this.query();
                        this.closeDialog();
                    }
                })
            },
            //导入
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback() {
                this.query();
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/dingd/declaration/oversea/downloadExcel",this.formInline,"post");
            },
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            addDeclaration(){
                this.uptitleDig = '新增报关主数据';
                this.updateVisDialogFlag = true;
            },
            selectPro(value){
                ss.declaration.selectProduct(value).then(rd => {
                    if(rd.f){
                        this.materialList = rd.obj;
                        // this.up.materialName = rd.obj.materialDescrition;
                        // this.up.weight = rd.obj.weight;
                        // this.up.netWeight = rd.obj.netWeight;
                        // this.up.volume = rd.obj.volume;
                        // this.up.measure = rd.obj.measure;
                    }
                })
            },
            changePro(){
                if(this.up.materialCode){
                    for(var i = 0;i<this.materialList.length;i++){
                        var data = this.materialList[i];
                        if(data.materialCode = this.up.materialCode){
                            this.up.materialName = data.materialDescrition;
                            this.up.weight = data.weight;
                            this.up.netWeight = data.netWeight;
                            this.up.volume = data.volume;
                            this.up.measure = data.measure;
                            this.up.oemDesc = data.oemDesc;//oem产品描述
                            //根据所选物料获取产地
                            ss.declaration.selectModel(this.up.materialCode).then(rd =>{
                                this.up.factory = rd.factory;
                            })
                        }
                    }
                }else {
                    this.up.materialName = null;
                    this.up.weight = null;
                    this.up.netWeight = null;
                    this.up.volume = null;
                    this.up.measure = null;
                    this.up.factory = null;
                }

            },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
        .oversea .h-formbLine .h-elformWrap-2 {
            padding-right: 0.1rem;
            width: 50%;
        }
        .oversea .h-formbLine .h-elformWrap-2 .el-form-item__label {
            width: 30%;
        }

        .oversea .h-formbLine .h-elformWrap-2 .el-form-item__content {
            width: 70%;
        }
    }
</style>
